module.exports = __webpack_public_path__ + "static/media/thesis_v2.8849688e.jpg";